import { useRecoilState } from 'recoil'
import { Spin } from 'antd'

import crashDetectionLockedModalAtom from '@/recoil/crashDetectionLockedModal'
import { useCrashDetectionDetail } from '@/services/crash-detection/useCrashDetectionDetail'
import { Modal, Title, Description } from './styles'
import { AssignCrashDetectionOwnerErrorCode } from '@/services/crash-detection/useAssignCrashDetectionOwner'

// Shown when a backoffice user tries to edit a crash case that is currently
// locked (assignStatus === "inProgress") by another owner within the 2-hour timeout.
// Single "รับทราบ" button that confirms and closes; no cancel, no header borderline.
function CrashDetectionLockedModal() {
  const [lockedModal, setLockedModal] = useRecoilState(crashDetectionLockedModalAtom)
  const { isVisible, ownerName, ownerEmployeeCode, errorCode, lockedCrashInfoId } = lockedModal
  const isLockedByMeOtherCase =
    errorCode === AssignCrashDetectionOwnerErrorCode.LOCKED_BY_CURRENT_USER_OTHER_CASE
  const { data: detailData, isLoading } = useCrashDetectionDetail(
    lockedCrashInfoId || '',
    isVisible && isLockedByMeOtherCase && !!lockedCrashInfoId,
  )

  const handleClose = () => {
    setLockedModal({
      isVisible: false,
      errorCode: null,
      ownerName: '',
      ownerEmployeeCode: '',
      lockedCrashInfoId: '',
    })
  }

  let descriptionContent: React.ReactNode = null
  if (isLockedByMeOtherCase) {
    if (isLoading) {
      descriptionContent = <Spin />
    } else {
      descriptionContent = `เคสของกรมธรรม์เลขที่ ${detailData?.policyNumber || '-'} ทะเบียนรถ ${
        detailData?.licensePlate || '-'
      }\nยังไม่ได้ปิดเคส\nกรุณาปิดเคสนี้ก่อนทำรายการอื่น`
    }
  } else {
    descriptionContent = `${ownerName || '-'} รหัส ${
      ownerEmployeeCode || '-'
    }\nกำลังอยู่ระหว่างแก้ไขรายการนี้`
  }

  return (
    <Modal
      open={isVisible}
      title={null}
      closable={false}
      centered
      onOk={handleClose}
      onCancel={handleClose}
      okText="รับทราบ"
      cancelButtonProps={{ style: { display: 'none' } }}
      zIndex={1060}
    >
      <Title>ไม่สามารถแก้ไขข้อมูลได้</Title>
      <Description style={{ whiteSpace: 'pre-line' }}>{descriptionContent}</Description>
    </Modal>
  )
}

export default CrashDetectionLockedModal
